module.exports = __webpack_public_path__ + "img/Instructivo-foto-carnet.1feee5d6.png";